import React from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./baseball.css";
import baseball_image_1 from "../../Assets/Images/Baseball/baseball_1.png";
import baseball_image_2 from "../../Assets/Images/Baseball/baseball_2.png";
import baseball_image_3 from "../../Assets/Images/Baseball/baseball_3.png";
import baseball_image_4 from "../../Assets/Images/Baseball/baseball_4.png";
import baseball_bg_1 from "../../Assets/Images/Baseball/baseball_bg_1.png";
import baseball_bg_1_m from "../../Assets/Images/Baseball/baseball_bg_1_m.png";
import baseball_info_1 from "../../Assets/Images/base1.png";
import baseball_info_2 from "../../Assets/Images/base2.png";
import baseball_info_3 from "../../Assets/Images/base3.png";
import baseball_info_4 from "../../Assets/Images/base4.png";
import baseball_info_5 from "../../Assets/Images/base5.png";

import baseball_section_image from "../../Assets/Images/baseball_section_image.png";

import dribbling from "../../Assets/Images/dribbling.png";
import shooting from "../../Assets/Images/shooting.png";
import passing from "../../Assets/Images/passing.png";
import defense from "../../Assets/Images/defense.png";
import rebounding from "../../Assets/Images/rebounding.png";
import soccer_trainer1 from "../../Assets/Images/trainer.png";
import soccer_trainer2 from "../../Assets/Images/trainer2.png";
import soccer_trainer3 from "../../Assets/Images/basketball_trainer3.png";
import stock_photo from "../../Assets/Images/stock_photo.png";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function Baseball() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };
  return (
    <>
      <SEO
        title="Instruction | Baseball | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/baseball"
      />
      <div className="baseball-container">
        <div className="baseball-header">
          <div className="base-sec">
            <div>
              <span className="baseball-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="baseball-header-content">
              <h1 className="black-text-clip">Baseball</h1>
              <h3 className="black-text-clip">
                Step Up to the Plate with BWC Baseball!
              </h3>
              <p className="black-text-clip">
                <strong>
                  Where Passion Meets Precision—Train with the Best in Staten
                  Island
                </strong>
              </p>
              <p className="black-text-clip">
                At BWC Baseball, we believe the diamond is more than just a
                field - it’s a place where young athletes can grow, challenge
                themselves, and have a blast while doing it. With our head
                instructor, Vinny D’Acunto, leading the way, we’re committed to
                teaching the next generation of players the skills and values
                that baseball instills.
              </p>
            </div>
          </div>
        </div>
        <div className="baseball-booking-container">
          <button
            className="one-on-one"
            style={{ cursor: "pointer" }}
            onClick={() => handleSubmit("1-1")}
          >
            <span
              style={{ "--clip-color": "#0D4597" }}
              className="black-text-clip"
            >
              Schedule for Classes Here
            </span>
          </button>
          {!user && (
            <button
              className="one-on-one-1 baseball-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer", color: "#FFFFFF !important" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>
        <div className="baseball-image-container">
          <img src={baseball_image_4} alt="soccer-image" />
          <img src={baseball_image_1} alt="soccer-image" />
          <img src={baseball_image_2} alt="soccer-image" />
          <img src={baseball_image_3} alt="soccer-image" />
        </div>
        <div className="baseball-section2">
          <h3 className="black-text-clip">Why Choose BWC Baseball?</h3>
          <p className="black-text-clip">
            At BWC Baseball, we offer a range of programs that are as
            comprehensive as they are fun. Our goal is to provide every player
            with the tools they need to succeed, both on and off the field. Our
            carefully designed drills and games create an environment where
            learning is exciting and improvement is inevitable.
          </p>
          <div className="baseball-section2-image-container">
            <span className="baseball-overlay-text bottom-left">
              1-on-1 Training
            </span>
            <div className="baseball-overlay-text top-right">
              <p className="black-text-clip">
                Join Our 1-on-1 Baseball Training
              </p>
              <p className="black-text-clip">
                Get personalized coaching tailored to your child’s skill level -
                perfect their swing, improve pitching, and build confidence on
                the field!
              </p>
              {!user && (
                <button onClick={() => handleSubmit("")} className="">
                  Sign Up for Classes Here
                </button>
              )}
            </div>
            <picture>
              <source media="(max-width: 300px)" srcSet={baseball_bg_1_m} />
              <source media="(max-width: 430px)" srcSet={baseball_bg_1_m} />
              <img src={baseball_bg_1} alt="session-img" />
            </picture>
          </div>
        </div>

        <div className="baseball-section3">
          <h3 className="black-text-clip">Dive into Our Exciting Programs</h3>
          <p className="black-text-clip">
            Our programs are packed with a variety of drills and games designed
            to sharpen your skills and boost your confidence:
          </p>
          <div className="baseball-section3-image-container">
            <div>
              <span className="skill-text-overlay">Infield</span>{" "}
              <span className="skill-text-overlay-para">
                Master ground balls, double plays, and quick transitions.
              </span>
              <img src={baseball_info_1} alt="Dribbling" />
            </div>
            <div>
              <span className="skill-text-overlay">Outfield</span>{" "}
              <span className="skill-text-overlay-para">
                Learn to track fly balls, improve your range, and make the
                perfect throw.
              </span>
              <img src={baseball_info_2} alt="Shooting" />
            </div>
            <div>
              <span className="skill-text-overlay">Catching</span>
              <span className="skill-text-overlay-para">
                Enhance your blocking, framing, and throwing techniques.
              </span>
              <img src={baseball_info_3} alt="Passing" />
            </div>
            <div>
              <span className="skill-text-overlay">Pitching</span>
              <span className="skill-text-overlay-para">
                Work on your mechanics, control, and pitch selection.
              </span>
              <img src={baseball_info_4} alt="Defense" />
            </div>
            <div>
              <span className="skill-text-overlay">Hitting</span>
              <span className="skill-text-overlay-para">
                Perfect your stance, swing, and timing for consistent contact.
              </span>
              <img src={baseball_info_5} alt="Rebounding" />
            </div>
          </div>
        </div>
        <div className="baseball-section4">
          <h3 className="black-text-clip">Scrimmages and Games</h3>
          <p className="black-text-clip">
            Practice makes perfect, but nothing beats game day. Our scrimmages
            and games give players the chance to apply what they’ve learned in a
            real-game setting, building confidence and experience. We cater to
            all skill levels, from ages 4 to 18, ensuring that every player
            finds their place on the field.
          </p>
        </div>
        <div className="baseball-booking-container2">
          <div className="baseball-booking-container-details">
            <h3 className="black-text-clip">READY TO GET STARTED?</h3>
            <p className="black-text-clip" style={{ fontWeight: "500" }}>
              Don’t miss out on this incredible opportunity to give your child
              the best start in basketball. Our spots fill up fast—secure your
              place today!
            </p>
            <p className="black-text-clip" style={{ fontWeight: "500" }}>
              <strong style={{ fontWeight: "600" }}>Sign Up Now</strong> –
              Empower your child to succeed on and off the court.
            </p>
          </div>
          <div className="baseball-booking-container inside-booking-container">
            <button
              className="one-on-one"
              style={{ color: "#0D4597" }}
              onClick={() => handleSubmit("1-1")}
            >
              Schedule for Classes Here
            </button>
            {!user && (
              <button
                className="one-on-one baseball-booking-selected"
                onClick={() => handleSubmit("")}
              >
                Sign Up for Classes Here
              </button>
            )}
          </div>
        </div>
        <div className="baseball-booking-container outside-booking-container">
          <button className="one-on-one" onClick={() => handleSubmit("1-1")}>
            <span className="black-text-clip">Schedule for Classes Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one baseball-booking-selected"
              onClick={() => handleSubmit("")}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>

        <div className="baseball-trainers">
          <h3 className="black-text-clip text-center">Our Trainers</h3>
          <div className="baseball-trainer-image-container">
            <div className="baseball-trainer-image">
              <div className="skill-text-overlay">
                <h4>Vin D’Acunto</h4>
                <p>Head Trainer</p>
              </div>
              <img src={soccer_trainer1} alt="trainer-image" />
            </div>
            <div className="baseball-trainer-image">
              {/* <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div> */}
              <img src={soccer_trainer2} alt="trainer-image" />
            </div>
            {/* <div className="baseball-trainer-image">
                            <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div>
                            <img src={soccer_trainer3} alt="trainer-image" />

                        </div> */}
          </div>
        </div>
        <div className="baseball-locations">
          <h3 className="black-text-clip text-center">Locations</h3>
          <div className="baseball-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3031.506888062871!2d-74.2323013!3d40.55248230000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b5278510b0f5%3A0xfea8687c67da4aae!2s79%20Industrial%20Loop%2C%20Staten%20Island%2C%20NY%2010309%2C%20USA!5e0!3m2!1sen!2sin!4v1773667757173!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>XTREME BASEBALL & SOFTBALL</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.615905386927!2d-74.14155559999999!3d40.6162973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c3387658829%3A0x770465e3707ce954!2sChurch%20of%20the%20Holy%20Family%2C%20366%20Watchogue%20Rd%2C%20Staten%20Island%2C%20NY%2010314%2C%20USA!5e0!3m2!1sen!2sin!4v1773669109457!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Holy Family</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3027.3080606153394!2d-74.0770379!3d40.645139199999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24e2b49581969%3A0x19809df14502598e!2s75%20Richmond%20Ter%2C%20Staten%20Island%2C%20NY%2010301%2C%20USA!5e0!3m2!1sen!2sin!4v1773669204541!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Staten Island FerryHawks</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3032.288499132894!2d-74.2398164!3d40.53521490000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53f9530b093%3A0x923a08def777405b!2s120%20Androvette%20St%2C%20Staten%20Island%2C%20NY%2010309%2C%20USA!5e0!3m2!1sen!2sin!4v1773669329205!5m2!1sen!2sin"
                width="600"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>JUMPSHOTZ</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
